export default [
  'SharedFavoriteItems'
]

/* Appears on /shared-favorites?id=gl1070992707 */
